import React from "react";
import { Box, Stack, Divider, Grid } from "@mui/material";
import StatsItem from "../../AcquireDashboard/Utilities/StatsItem";
import { formatProactiveMetric } from "../../Proactive/Utilities/CampaignUtils";
import AttributionEmptyState from "./AttributionEmptyState";

export default function PerformanceMetrics({ data, loading }) {
  const formatMetric = (value) =>
    value === 0 ?  '-' :formatProactiveMetric(value)

  return (
    <Box mt={{ xs: "14px", sm: "20px" }}>
      <Stack
        sx={styles.root}
        direction={"column"}
        divider={<Divider orientation={"horizontal"} flexItem />}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={1}
          sx={styles.header}
        >
          <Box component={"h2"} sx={styles.headerTitle}>
            Performance Metrics
          </Box>
        </Stack>

        {loading && <AttributionEmptyState />}

        {!loading && (
          <Grid container columns={4} spacing={3} sx={styles.gridStyle}>
            <StatsItem
              label={"Total Revenue"}
              entry={{ value: data?.totalRevenue, formatStyle: "currency" }}
              descriptionChildren={
                <Box>
                  Includes {data?.winbackRevenue === '-' ? 0 : data?.winbackRevenue } winback revenue and{" "}
                  {data?.additionalRevenue === "-" ? 0 : data?.additionalRevenue} additional revenue
                </Box>
              }
            />
            <StatsItem
              label={"Attributed Revenue"}
              entry={{
                value: data?.attributedRevenue,
                formatStyle: "currency",
              }}
              descriptionChildren={
                <Box>
                  {data?.attributedWinbacks} attributed winbacks
                  <br />
                  {data?.attributedRevenuePerRecipient === "-" ? 0 : data?.attributedRevenuePerRecipient} attributed revenue per
                  recipient
                </Box>
              }
            />
            <StatsItem
              label={"Revenue Per Recipient"}
              entry={{
                value: data?.revenuePerRecipient,
                formatStyle: "currency",
              }}
              descriptionChildren={
                <Box>
                  {data?.winbacks} winbacks from {data?.totalRecipients}{" "}
                  recipients ({formatProactiveMetric(data?.winbackRate)})
                </Box>
              }
            />
            <StatsItem
              label={"LTV Increase"}
              entry={{ value: formatMetric(data?.ltvIncreaseRatio) }}
              descriptionChildren={
                <Box>Increase in LTV from customers won back</Box>
              }
            />
          </Grid>
        )}
      </Stack>
    </Box>
  );
}

const styles = {
  root: {
    borderRadius: "10px",
    border: "1px solid #B6BEBF98",
    background: "#fff",
  },

  header: {
    alignItems: { xs: "flex-start", md: "center" },
    justifyContent: "space-between",
    px: { xs: 2, md: 4 },
    py: { xs: 2, md: 0 },
    minHeight: { xs: "auto", md: "73px" },
    zIndex: 10, // MUI draws a big padding over the header, so we need to make sure the header is on top so it's still interactable.
  },
  headerTitle: {
    m: 0,
    fontFamily: "FustatBold",
    fontSize: { xs: "14px", md: "19px" },
  },
  gridStyle: {
    position: "relative",
    px: { xs: 2, md: 4 },
    py: { xs: 2, md: 4 },
  },
};
